import script from "./AdvicePw.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvicePw.vue?vue&type=script&setup=true&lang=js"

import "./AdvicePw.vue?vue&type=style&index=0&id=e990d3ce&scope=true&lang=css"

const __exports__ = script;

export default __exports__